import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFavouriteFilled = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="m12.006 20-7.851-7.024C-.112 8.76 6.16.669 12.005 7.216c5.846-6.547 12.09 1.573 7.852 5.76z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.67 12.43c-1.761-1.753-1.384-4.336.143-5.834.75-.735 1.744-1.166 2.846-1.087 1.103.08 2.421.676 3.787 2.206a.75.75 0 0 0 1.12 0c1.365-1.53 2.682-2.125 3.78-2.202 1.1-.077 2.093.356 2.84 1.092 1.527 1.504 1.9 4.087.156 5.825l-7.336 6.564zm7.336-6.298c-1.39-1.35-2.844-2.019-4.24-2.119-1.583-.113-2.986.515-4.003 1.512-2 1.961-2.627 5.523-.135 7.984l.027.026 7.85 7.024a.75.75 0 0 0 1 0l7.852-7.024.027-.026c2.479-2.449 1.848-6.01-.145-7.973-1.014-.998-2.414-1.63-3.997-1.519-1.395.098-2.846.765-4.236 2.115"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFavouriteFilled;
